import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import {Button, Card, CardContent, CardHeader, Divider, Grid, TextField, makeStyles, } from "@material-ui/core";
import * as Yup from "yup";
import { Formik } from "formik";
import Page from 'src/components/Page';
import { Link as RouterLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3)      
  },
  otherButton: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3)
  }  
}));

const initialValues = {
    vehicleType: "",
    plate: "",
    passengerCapacity: "",
    status: "",
};

const validationSchema = Yup.object().shape({
    vehicleType: Yup.string().required(),
    plate: Yup.string().required(),
    passengerCapacity: Yup.string().required(),
    status: Yup.string().required(),
});

const onSubmit = (values) => {
    console.log(values);
};

const VehicleRentingForm = ({ className, ...rest }) => {
  const classes = useStyles(); 

  return (
    <Page className={classes.root} title="Vehicle Renting Details">
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
        {({ errors, handleBlur, handleChange, handleSubmit, resetForm, isSubmitting, touched, values, status }) => (
      <form onSubmit={handleSubmit} autoComplete="off" noValidate className={clsx(classes.root, className)} {...rest} >
        <Card>
          <Button className={classes.otherButton} variant="outlined" component={RouterLink} to="../asset_management">Back to Asset Management</Button>
          <CardHeader title="Rent Vehicle"/>
          <Divider />
          <CardContent>
            <Grid container spacing={3}>
            <Grid item md={6} xs={12}>
                <TextField fullWidth label="Firm" name="firm"  variant="outlined" error={Boolean(touched.firm && errors.firm)} onBlur={handleBlur} onChange={handleChange} value={values.firm} />
              </Grid>
              <Grid item md={6} xs={12}></Grid>
              <Grid item md={6} xs={12}>
                <TextField fullWidth label="Renting Price" name="rentingPrice"  variant="outlined" error={Boolean(touched.rentingPrice && errors.rentingPrice)} onBlur={handleBlur} onChange={handleChange} value={values.rentingPrice} /> 
              </Grid>
              <Grid item md={6} xs={12}></Grid>
              <Grid item md={3} xs={6}>
                <TextField fullWidth label="Start Date" name="startDate"  variant="outlined" error={Boolean(touched.startDate && errors.startDate)} onBlur={handleBlur} onChange={handleChange} value={values.startDate} />
              </Grid>
              <Grid item md={3} xs={6}>
                <TextField fullWidth label="End Date" name="endDate"  variant="outlined" error={Boolean(touched.endDate && errors.endDate)} onBlur={handleBlur} onChange={handleChange} value={values.endDate} /> 
              </Grid>
              <Grid item md={6} xs={12}></Grid>
              <Grid item md={6} xs={12}>
                <TextField fullWidth label="Vehicle Type" name="vehicleType"  variant="outlined" error={Boolean(touched.vehicleType && errors.vehicleType)} onBlur={handleBlur} onChange={handleChange} value={values.vehicleType} />
              </Grid>
              <Grid item md={6} xs={12}></Grid>
              <Grid item md={3} xs={6}>
                <TextField fullWidth label="Plate" name="plate" variant="outlined" error={Boolean(touched.plate && errors.plate)} onBlur={handleBlur} onChange={handleChange} value={values.plate} />
              </Grid>
              <Grid item md={3} xs={6}>
                <TextField fullWidth label="Passenger Capacity" name="passengerCapacity"  variant="outlined" error={Boolean(touched.passengerCapacity && errors.passengerCapacity)} onBlur={handleBlur} onChange={handleChange} value={values.passengerCapacity} />
              </Grid>
            </Grid>
          </CardContent>
          <Button className={classes.otherButton} color="primary" variant="outlined" >Rent</Button>    
        </Card>
      </form>
            )}
    </Formik>
    </Page>
  );
};

VehicleRentingForm.propTypes = {
  className: PropTypes.string,
};

export default VehicleRentingForm;
